import React, { useState } from "react";
import { Analytics } from "@vercel/analytics/react"
import {
  Github,
  Linkedin,
  Mail,
  ExternalLink,
  Code2,
  GraduationCap,
  Smartphone,
  Database,
  Layout,
  Menu,
  X,
  ShoppingBasket,
  ShoppingCart,
} from "lucide-react";

export default function Portfolio() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedSkill, setSelectedSkill] = useState(null);

  const projects = [
    {
      id: 1,
      title: "Aplicación ecommerce",
      description:
        "Aplicacion de uso comercial para compra y venta de productos, frontend en Angular v20, backend en .NET 9 + PostgreSQL + JWT + Docker, desarrollada con arquitectura limpia y buenas prácticas. Deployada en VPS y Vercel.",
      icon: <i class="devicon-angular-plain text-5xl"></i>,
      tech: ["Angular", ".NET", "PostgreSQL", "JWT", "Docker"],
      category: "Full stack web",
      highlights: [
        "Autenticación con tokens",
        "API RESTful",
        "Base de datos SQL",
        "Clean Architecture",
      ],
      link: ["https://app.salvame.com.ar"],
    },
    {
      id: 2,
      title: "Sistema Web Django",
      description:
        "Aplicación web full-stack con Django + PostgreSQL, con gestión de datos CRUD mediante interfaz o panel de administracion de Django. Frontend utilizando el motor de plantillas de Django.",
      icon: <i class="devicon-django-plain text-5xl"></i>,
      tech: ["Django", "PostgreSQL", "MVT"],
      category: "Full Stack Web",
      highlights: [
        "Monolito",
        "API RESTful",
        "Base de datos SQL",
      ],
      link: ["https://github.com/pala83/Django-cac"],
    },
    {
      id: 3,
      title: "Sistema web Flask ",
      description:
        "Aplicación Flask + MySQL con frontend utilizando el motor de plantillas Jinja2 y Tailwind CSS para una cerveceria, con sistema CRUD utilizando SQLAlchemy y arquitectura MVC.",
      icon: <i class="devicon-flask-original text-5xl"></i>,
      tech: ["Flask", "Jinja2", "TailwindCSS", "SQLAlchemy"],
      category: "Full stack web",
      highlights: [
        "Arquitectura MVC",
        "Sistema CRUD",
        "Base de datos SQL",
      ],
      link: ["https://github.com/pala83/Brewery-flask"],
    },
    {
      id: 4,
      title: "Sistema para agenda de turnos",
      description:
        "Sistema serverless para gestión de agenda de citas/turnos mediante Google Calendar, con frontend en Qwik, OAuth2 con Google y backend en Google Cloud Functions.",
      icon: <i class="devicon-qwik-plain text-5xl"></i>,
      tech: ["Qwik", "Google platform", "Tailwindcss", "OAuth2"],
      category: "Frontend Development",
      highlights: [
        "Resumability",
        "Google Apis",
        "Serverless",
      ],
      link: ["https://qwik-turnero-google.vercel.app/"],
    },
    {
      id: 5,
      title: "Aplicación ecommerce",
      description:
        "Aplicación React + Mockapi para una panaderia, con carrito de compras, filtros y búsqueda de productos. Diseño responsivo y moderno con Tailwind CSS, sistema CRUD mediante autenticacion.",
      icon: <i class="devicon-react-original text-5xl"></i>,
      tech: ["React", "Mockapi", "TailwindCSS", "CRUD"],
      category: "Frontend Development",
      highlights: [
        "Diseño responsivo",
        "Sistema CRUD",
        "SPA",
      ],
      link: ["https://panaderia-eta.vercel.app/"],
    },
    {
      id: 6,
      title: "API Restful con microservicios",
      description:
        "API implemendada con arquitectura de microservicios utilizando Spring Boot, Docker y multiples bases de datos (Postgres, MySQL, Mongo). Cada microservicio es independiente y se comunica mediante Feign Client. Toda la aplicacion está dockerizada para facilitar su despliegue.",
      icon: <i class="devicon-spring-original text-5xl"></i>,
      tech: ["Spring Boot", "Docker", "Microservices", "SQL", "NoSQL", "JWT", "Groq IA"],
      category: "Backend Development",
      highlights: [
        "Microservicios",
        "Docker",
        "Bases de datos múltiples",
      ],
      link: ["https://panaderia-eta.vercel.app/"],
    },
    {
      id: 7,
      title: "API Restful MVC",
      description:
        "API Restful desarrollada unicamente con PHP, Apache, utilizando arquitectura MVC y base de datos MySQL. Se implemento una interfaz simple con el motor de plantillas Smarty y Bootstrap para la gestión de datos CRUD.",
      icon: <i class="devicon-php-plain text-5xl"></i>,
      tech: ["PHP", "Apache", "MySQL", "Bootstrap", "Smarty"],
      category: "Backend Development",
      highlights: [
        "Arquitectura MVC",
        "Sistema CRUD",
        "Diagramas UML",
      ],
      link: ["https://github.com/pala83/Remate-PHP-API", "https://github.com/pala83/Remate-PHP"],
    },
    {
      id: 8,
      title: "Web estática",
      description:
        "Página web estática para una cervecería artesanal, desarrollada con tecnología web nativa (HTML, CSS, JS). Diseño responsivo y simple utilizando Figma.",
      icon: <i class="devicon-html5-plain text-5xl"></i>,
      tech: ["HTML", "CSS", "JavaScript"],
      category: "Frontend Development",
      highlights: [
        "Diseño responsivo",
        "Tecnología web nativa",
        "Figma",
      ],
      link: ["https://pala83.github.io/Brewery/"],
    },
    {
      id: 9,
      title: "Proyectos académicos",
      description:
        "Proyectos web desarrollados durante la carrera, utilizando lenguajes nativos, maquetado en Figma y trabajo en equipo utilizando metodologías ágiles.",
      icon: <i class="devicon-javascript-plain text-5xl"></i>,
      tech: ["HTML", "CSS", "JavaScript"],
      category: "Frontend Development",
      highlights: [
        "Diseño responsivo",
        "Tecnología web nativa",
        "Figma",
      ],
      link: [
        "https://malinowsk.github.io/inicio.html",
        "https://pala83.github.io/front-end-design/"
      ]
    },
  ];

  const skills = [
    { category: "Lenguajes", items: ["TypeScript", "JavaScript", "Java", "PHP", "Python", "C++"] },
    {
      category: "Frameworks & Libraries",
      items: ["Angular", "Qwik", "React", "Spring Boot", "TailwindCSS", "Django"],
    },
    { category: "Bases de Datos", items: ["PostgreSQL", "MySQL", "MongoDB"] },
    { category: "Testing", items: ["JUnit", "TestNG"] },
  ];

  return (
    <>
      <Analytics />
      <div className="min-h-screen bg-white text-gray-900">
        {/* Navigation */}
        <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm z-50 border-b border-gray-200 shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="text-2xl font-bold text-black">UP</div>

              <div className="hidden md:flex space-x-8">
                <a
                  href="#inicio"
                  className="text-gray-700 hover:text-black transition font-medium"
                >
                  Inicio
                </a>
                <a
                  href="#proyectos"
                  className="text-gray-700 hover:text-black transition font-medium"
                >
                  Proyectos
                </a>
                <a
                  href="#skills"
                  className="text-gray-700 hover:text-black transition font-medium"
                >
                  Habilidades
                </a>
                <a
                  href="#contacto"
                  className="text-gray-700 hover:text-black transition font-medium"
                >
                  Contacto
                </a>
              </div>

              <button
                className="md:hidden text-black"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                {menuOpen ? <X /> : <Menu />}
              </button>
            </div>
          </div>

          {menuOpen && (
            <div className="md:hidden bg-white border-t border-gray-200">
              <div className="px-4 py-4 space-y-3">
                <a
                  href="#inicio"
                  className="block text-gray-700 hover:text-black font-medium"
                >
                  Inicio
                </a>
                <a
                  href="#proyectos"
                  className="block text-gray-700 hover:text-black font-medium"
                >
                  Proyectos
                </a>
                <a
                  href="#skills"
                  className="block text-gray-700 hover:text-black font-medium"
                >
                  Habilidades
                </a>
                <a
                  href="#contacto"
                  className="block text-gray-700 hover:text-black font-medium"
                >
                  Contacto
                </a>
              </div>
            </div>
          )}
        </nav>

        {/* Hero Section */}
        <section
          id="inicio"
          className="pt-32 pb-20 px-4 bg-gradient-to-b from-gray-50 to-white"
        >
          <div className="max-w-7xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <div className="inline-block mb-4 px-4 py-2 bg-black text-white text-sm font-medium rounded-full">
                  Disponible para colaborar
                </div>
                <h1 className="text-5xl md:text-6xl font-bold mb-6 text-black">
                  Ulises Palazzo
                </h1>
                <p className="text-lg text-gray-600 mb-2">Tandil - Argentina</p>
                <p className="text-xl text-gray-600 mb-4 leading-relaxed">
                  <span className="font-semibold text-black">
                    Tecnico Universitario en Desarrollo de Aplicaciones
                    Informaticas - UNICEN
                  </span>{" "}
                </p>
                <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                  Especializado en la construcción de aplicaciones robustas y de alto rendimiento, con enfoque en código escalable, mantenible y aplicando buenas prácticas de ingeniería y estándares modernos para garantizar la mejor experiencia del usuario.
                </p>
                <div className="flex gap-4 mb-8">
                  <a
                    href="#proyectos"
                    className="px-6 py-3 bg-black text-white font-medium rounded-lg hover:bg-gray-800 transition"
                  >
                    Ver Proyectos
                  </a>
                  <a
                    href="#contacto"
                    className="px-6 py-3 border-2 border-black text-black font-medium rounded-lg hover:bg-black hover:text-white transition"
                  >
                    Contacto
                  </a>
                </div>
                <div className="flex gap-4">
                  <a
                    href="https://github.com/pala83"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-3 border border-gray-300 hover:border-black rounded-lg transition"
                  >
                    <Github size={24} />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/ulises-palazzo/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-3 border border-gray-300 hover:border-black rounded-lg transition"
                  >
                    <Linkedin size={24} />
                  </a>
                  <a
                    href="mailto:ulipalazzoo@gmail.com"
                    className="p-3 border border-gray-300 hover:border-black rounded-lg transition"
                  >
                    <Mail size={24} />
                  </a>
                </div>
              </div>
              <div className="hidden md:block">
                <div className="relative">
                  <div className="absolute inset-1 bg-gradient-to-br from-gray-200 to-gray-300 rounded-2xl transform rotate-6"></div>
                  <div className="relative bg-white rounded-2xl overflow-hidden border-2 border-gray-300 shadow-lg">
                    <img
                      src="/portfolio/foto-ulises.jpg"
                      alt="Ulises Palazzo"
                      className="w-full h-96 object-cover"
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                    />
                    <div
                      className="w-full h-96 bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center"
                      style={{ display: "none" }}
                    >
                      <Code2 className="w-48 h-48 text-gray-400" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Projects Section */}
        <section id="proyectos" className="py-20 px-4 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-black">
                Proyectos Destacados
              </h2>
              <p className="text-gray-600 text-lg">
                Desarrollo web con tecnologías modernas
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {projects.map((project) => (
                <div
                  key={project.id}
                  className="group bg-white rounded-xl border-2 border-gray-200 hover:border-black transition-all duration-300 overflow-hidden"
                >
                  <div className="p-8">
                    <div className="mb-6 text-gray-400 group-hover:text-black transition-colors">
                      {project.icon}
                    </div>
                    <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">
                      {project.category}
                    </div>
                    <h3 className="text-2xl font-bold mb-3 text-black group-hover:underline">
                      {project.title}
                    </h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">
                      {project.description}
                    </p>
                    <div className="mb-6">
                      {project.highlights.map((highlight, i) => (
                        <div
                          key={i}
                          className="flex items-center gap-2 mb-2 text-sm text-gray-700"
                        >
                          <div className="w-1.5 h-1.5 bg-black rounded-full"></div>
                          {highlight}
                        </div>
                      ))}
                    </div>
                    <div className="flex flex-wrap gap-2 mb-6">
                      {project.tech.map((tech, i) => (
                        <span
                          key={i}
                          className="text-xs bg-gray-100 border border-gray-300 px-3 py-1 rounded-full font-medium"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                    <div className="flex flex-col gap-2">

                      {
                        Array.isArray(project.link) ? (
                          project.link.map((link, i) => (
                            <a
                              key={i}
                              href={link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="inline-flex items-center gap-2 text-black font-medium hover:gap-3 transition-all mr-4"
                            >
                              Ver proyecto <ExternalLink size={16} />
                            </a>
                          ))
                        ) : (
                          <></>
                        )
                      }
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Skills Section */}
        <section id="skills" className="py-20 px-4 bg-gray-50">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-black">
                Habilidades Técnicas
              </h2>
              <p className="text-gray-600 text-lg">
                Tecnologías y metodologías que domino
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {skills.map((skillGroup, i) => (
                <div
                  key={i}
                  className="bg-white rounded-xl border-2 border-gray-200 p-8 hover:border-black transition-all"
                >
                  <h3 className="text-xl font-bold mb-6 text-black flex items-center gap-3">
                    <div className="w-2 h-8 bg-black rounded"></div>
                    {skillGroup.category}
                  </h3>
                  <div className="grid grid-cols-2 gap-4">
                    {skillGroup.items.map((skill, j) => (
                      <div
                        key={j}
                        className="bg-gray-50 border border-gray-200 px-4 py-3 rounded-lg font-medium text-gray-800 hover:bg-black hover:text-white transition-all cursor-default"
                      >
                        {skill}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-12 bg-white rounded-xl border-2 border-gray-200 p-8">
              <h3 className="text-xl font-bold mb-4 text-black">Idiomas</h3>
              <div className="flex flex-wrap gap-3">
                <span className="px-4 py-2 bg-black text-white rounded-lg font-medium">
                  Español - Nativo
                </span>
                <span className="px-4 py-2 bg-black text-white rounded-lg font-medium">
                  Inglés - Básico (B2)
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="py-20 px-4 bg-white">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl border-2 border-gray-200 p-12">
              <div className="flex items-center gap-4 mb-6">
                <GraduationCap className="w-12 h-12 text-black" />
                <h2 className="text-3xl font-bold text-black">Sobre mí</h2>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed mb-4">
                Trabaje en el sector rural desde 2018 y actualmente administro un emprendimiento familiar sobre remates de articulos y propiedades {" "}
                <span className="font-semibold text-black"> Remates Palazzo. </span>
              </p>
              <p className="text-gray-700 text-lg leading-relaxed mb-4">
                Soy {" "}
                <span className="font-semibold text-black">
                  Tecnico Universitario en Desarrollo de Aplicaciones
                  Informaticas - UNICEN
                </span>
                {" "} aunque de forma resumida me gusta definirlo como {" "}
                <span className="font-semibold text-black">
                  Programador web.
                </span>
                {" "} Tambien tengo formacion como {" "}
                <span className="font-semibold text-black">
                  Ingeniero en Sistemas
                </span>
                {" "} (cursado hasta 4to año).
              </p>
              <p className="text-gray-700 text-lg leading-relaxed">
                Mi experiencia como Freelancer desde el 2020 me ayuda a tener una visión amplia sobre los requisitos de un proyecto y como llevarlo a cabo utilizando la tecnología que mejor se adapte.
              </p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contacto" className="py-20 px-4 bg-gray-50">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black">
              ¿Trabajamos juntos?
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Estoy abierto a nuevas oportunidades, colaboraciones y proyectos
              desafiantes
            </p>
            <a
              href="mailto:ulipalazzoo@gmail.com"
              className="inline-block bg-black text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-800 transition transform hover:scale-105"
            >
              Enviar mensaje
            </a>
          </div>
        </section>

        {/* Footer */}
        <footer className="py-8 px-4 border-t-2 border-gray-200 bg-white">
          <div className="max-w-7xl mx-auto text-center text-gray-600">
            <p className="font-medium">
              🄯 2025 Ulises Palazzo. Ningun derecho reservado.
            </p>
          </div>
        </footer>
      </div>
    </>
  );
}
